import { render, staticRenderFns } from "./QDigitalLeadOrderDataTable.vue?vue&type=template&id=08db5926&scoped=true&"
import script from "./QDigitalLeadOrderDataTable.vue?vue&type=script&lang=js&"
export * from "./QDigitalLeadOrderDataTable.vue?vue&type=script&lang=js&"
import style0 from "./QDigitalLeadOrderDataTable.vue?vue&type=style&index=0&id=08db5926&prod&scoped=true&lang=css&"
import style1 from "./QDigitalLeadOrderDataTable.vue?vue&type=style&index=1&id=08db5926&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08db5926",
  null
  
)

export default component.exports